import { render } from "./brandsTeaser.vue?vue&type=template&id=244574bc"
import script from "./brandsTeaser.vue?vue&type=script&lang=js"
export * from "./brandsTeaser.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__